import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import RoadsTable from '../RoadsTable';
import SelectedRoadsTable from '../SelectedRoadsTable';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import MonitoredRoadsTable from '../MonitoredRoadsTable';

// From 'Tabs (Introduction)' MUI example (https://mui.com/material-ui/react-tabs/#introduction)

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`table-tabpanel-${index}`}
      aria-labelledby={`table-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function TableTabs(
  {data, mapRef, geoLayerRef, fromToTable, setFromToTable, tableTabValue, setTableTabValue, tableWidth, showOnMapData, setShowOnMapData, showOnMapMonitoredData, setShowOnMapMonitoredData, pagination, setPagination, category, year, layer }
) {

  const theme = useTheme()
  const { pathname } = useLocation()

  const handleChange = (e, newValue) => {
    setTableTabValue(newValue);
  };

  return (
    <Box id='table-with-tabs' sx={{width: `${tableWidth}vw`}}>
      <Tabs
        variant="fullWidth"
        value={tableTabValue}
        onChange={handleChange}
        aria-label="table tabs"
        sx={{
          backgroundColor: theme.palette.mode === 'light' ? '#efefef' : theme.palette.background.default,
          height: '5vh'
        }}
      >
        <Tab label="Summary" id="Summary" aria-controls='tabpanel-summary' sx={{ fontWeight: 700 }} />
        <Tab label="Selected Roads" id="Selected Roads" aria-controls='tabpanel-custom-summary' sx={{ fontWeight: 700 }} />
        { pathname === '/mpo' && <Tab label="Monitored Roads" id="MPO Data" aria-controls='tabpanel-data' sx={{ fontWeight: 700 }} /> }
      </Tabs>
      <CustomTabPanel value={tableTabValue} index={0}>
        {/* Main Summary table */}
        <RoadsTable data={data} mapRef={mapRef} geoLayerRef={geoLayerRef} showOnMapData={showOnMapData} setShowOnMapData={setShowOnMapData} pagination={pagination} setPagination={setPagination} category={category} year={year} layer={layer} />
      </CustomTabPanel>
      <CustomTabPanel value={tableTabValue} index={1}>
        <SelectedRoadsTable fromToTable={fromToTable} setFromToTable={setFromToTable} mapRef={mapRef} showOnMapData={showOnMapData} setShowOnMapData={setShowOnMapData} />
      </CustomTabPanel>
      { pathname === '/mpo' &&
        <CustomTabPanel value={tableTabValue} index={2}>
          <MonitoredRoadsTable data={data} showOnMapData={showOnMapMonitoredData} setShowOnMapData={setShowOnMapMonitoredData} year={year} layer={layer} />
        </CustomTabPanel>
      }
    </Box>
  );
}